<br>
  <div>
    <span class="headerText">Skills/Certifications</span>
    <div style="float:right">
      <div>
        <p-button type="button" class="addNewButton" (click)="addNew();">Add New</p-button>
      </div>
    </div>
  </div>
  <br>
    <p-table showGridlines stripedRows responsiveLayout="stack" [columns]="cols" [value]="skills" [paginator]="true" [rows]="30">
      <ng-template pTemplate="header" let-columns>
        <tr>
          @for (col of columns; track col) {
            <th [pSortableColumn]="col.field" [style.width]="col.width">
              {{col.header}}
              @if (col.header != '') {
                <p-sortIcon [field]="col.field" ariaLabel="Activate to sort" ariaLabelDesc="Activate to sort in descending order" ariaLabelAsc="Activate to sort in ascending order"></p-sortIcon>
              }
            </th>
          }
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-skill
        let-columns="columns"
        let-rowIndex="rowIndex">
        <tr>
          @for (col of columns; track col) {
            @if (col.type !== 'actions') {
              <td>
                <span class="p-column-title">{{col.header}}</span>{{skill[col.field]}}
              </td>
            }
            @if (col.type === 'actions') {
              <td>
                <p-button
                  
                  type="button"
                  icon="pi pi-pencil"
                  (click)="editSkill(skill)"
                  severity="info" >
                </p-button>
                <p-button
                  
                  type="button"
                  icon="pi pi-trash"
                  (click)="deleteSkill(skill)"
                  severity="danger">
                </p-button>
              </td>
            }
          }
        </tr>
      </ng-template>
    </p-table>
